import React from "react";

function Footer() {

    const currentYear = new Date().getFullYear();
    return(
        <footer className="bg-gray-800 text-xl text-yellow-100  text-center  p-4">
            <p>
                Walter K. Chege 
                <br />
                Designed & Built by <b>Tersly</b> with ♥️ ☯️
                <br />
                Copyright &copy;  {currentYear}
            </p>
        </footer>
    )
}

export default Footer;


// WEBPACK FOOTER //
// ./src/Components/Footer.jsx